import React from "react";
import { useTranslation } from "react-i18next";
import "../styles/ServiceAmount.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";

const OrderConfirmationPopup = ({ onClose, orderResponse }) => {
  const { t } = useTranslation();

  if (!orderResponse) return null; // avoid rendering if no response yet

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <div className="popup-header">
          <FontAwesomeIcon icon={faCheckCircle} className="popup-icon" />
          <h5 className="popup-title">{t("thank_you_order")}</h5>
          <button className="popup-close" onClick={onClose}>
            X
          </button>
        </div>

        <div className="popup-body order-confirmation">
          <h6>{t("order_details")}</h6>
          <div className="order-details">
            {/* LEFT SIDE */}
            <div className="order-left">
              <div className="order-row">
                <span className="order-label">{t("service_purchased")}</span>
                <span className="order-value" style={{ 
                  overflow: 'hidden', 
                  textOverflow: 'ellipsis', 
                  whiteSpace: 'nowrap',
                  maxWidth: '200px'
                }} title={orderResponse.servicePurchased}>{orderResponse.servicePurchased}</span>
              </div>
              <div className="order-row">
                <span className="order-label">{t("connected_total_minutes")}</span>
                <span className="order-value">{orderResponse.connectedTotalMinutes}</span>
              </div>
              <div className="order-row">
                <span className="order-label">{t("whatsapp")}</span>
                <span className="order-value">{orderResponse.whatsApp}</span>
              </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="order-right">
              <div className="order-row">
                <span className="order-label">{t("order_id")}</span>
                <span className="order-value">{orderResponse.orderId}</span>
              </div>
              <div className="order-row">
                <span className="order-label">{t("order_date")}</span>
                <span className="order-value">{orderResponse.orderDate}</span>
              </div>
              <div className="order-row">
                <span className="order-label">{t("order_number")}</span>
                <span className="order-value">{orderResponse.orderNumber}</span>
              </div>
              <div className="order-row">
                <span className="order-label">{t("total_cost")}</span>
                <span className="order-value">INR {orderResponse.totalCost}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmationPopup;
